export const environment = {
  production: false,
  muneerClientId: 'a0aad7a0-39bb-49a0-a3e2-a578dc393973',

  apiUrl: 'https://portal.api.maeen-library.com/api/',
  filesPath: 'https://portal.api.maeen-library.comm/Files/',
  imagePrefix: 'https://portal.api.maeen-library.com/Files/',

  authPath:
    'https://sso.maeen-library.com/.well-known/openid-configuration',
  portalUrl: 'https://portal.maeen-library.com',
  lastUpdated: '2025-11-23T10:10:00Z',
  allowedHosts: ['maeen-library.com']
};
